import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export type Board = {
  id: number;
  user_id: string;
  title: string;
  description?: string | null;
};

type Props = {
  name: string;
  label?: string;
  defaultValue?: number;
  value?: number | undefined;
  onChange: (boardId: number) => void;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  boards: Board[] | undefined;
};

export default function BoardSelect(props: Props) {
  const {
    name,
    label,
    onChange,
    defaultValue,
    value,
    disabled,
    required,
    boards,
  } = props;

  return (
    <FormControl fullWidth>
      <InputLabel id="board-select">{label || "Boards"}</InputLabel>
      <Select
        labelId="board-select"
        required={required}
        name={name}
        label={label || "Board"}
        disabled={disabled}
        value={value ? value : ""}
        defaultValue={defaultValue}
        MenuProps={{ disablePortal: true }}
        onChange={(e) => onChange(e.target.value as number)}
      >
        {boards?.map((board) => (
          <MenuItem key={board.id} value={board.id}>
            {board.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
